interface PhraseMap {
  [key: string]: string;
}

interface ConditionalPhrase {
  condition: string;
  phrases: PhraseMap;
}

interface AllPhrases {
  conditionalPhrases: ConditionalPhrase[];
  phrases: PhraseMap;
}

export const allPhrases: AllPhrases = {
  conditionalPhrases: [
    {
      condition: 'Who_needs_help=child',
      phrases: {
        are_you: 'Is your child',
        could_you: 'Could your child',
        did_you: 'Did your child',
        do_you: 'Does your child',
        have_you: 'Has your child',
        i: 'They',
        i_am: 'They are',
        im: "They're",
        will_you: 'Will your child',
        would_you: 'Would your child',
        you: 'Your child',
        you_are: 'Your child is',
        your: "Your child's",
      },
    },
    {
      condition: 'Who_needs_help=other|employee|someone|friend',
      phrases: {
        are_you: 'are they',
        could_you: 'Could they',
        did_you: 'Did they',
        do_you: 'Do they',
        have_you: 'Have they',
        i: 'They',
        i_am: 'They are',
        im: "They're",
        will_you: 'Will they',
        would_you: 'Would they',
        you: 'Them',
        you_are: 'They are',
        your: 'Their',
      },
    },
  ],
  phrases: {
    are_you: 'Are you',
    could_you: 'Could you',
    did_you: 'Did you',
    do_you: 'Do you',
    have_you: 'Have you',
    i: 'I',
    i_am: 'I am',
    im: "I'm",
    will_you: 'Will you',
    would_you: 'Would you',
    you: 'You',
    you_are: 'You are',
    your: 'Your',
  },
};

export interface GetPhrasesProps {
  who_needs_help: string;
}

export default function getPhrases(getPhrasesProps?: GetPhrasesProps) {
  if (!getPhrasesProps?.who_needs_help) return allPhrases.phrases;

  const lowerCaseCondition = getPhrasesProps.who_needs_help.toLowerCase();

  return (
    allPhrases.conditionalPhrases.find(({ condition }) => {
      const regex = new RegExp(condition.split('=').at(1));

      return regex.test(lowerCaseCondition);
    })?.phrases ?? allPhrases.phrases
  );
}
